/* eslint-disable @typescript-eslint/no-shadow */
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Bounds, CarouselLayout, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { nullBounds, toBounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/utils';
import { ImpactTargetOrSbtiTarget } from '@upright/ui/common/upright/core/impact-lenses/targets/common/types';

interface TargetLensLayout {
  impactTargetSymbolArea: (side: Side, impact: ImpactCategoryId) => Bounds;
}

export function targetLensLayout(
  base: CarouselLayout,
  targets: ImpactTargetOrSbtiTarget[] | undefined,
): TargetLensLayout {
  /**
   * Area for symbol indicating whether company has
   * set a target within this category
   */
  function impactTargetSymbolArea(side: Side, impact: ImpactCategoryId) {
    if (!targets) {
      return nullBounds; // TODO
    }
    const da = base.impactDataArea(side, impact);
    const horizontalMargin = 10;
    // const height = da.height / 3;
    const height = da.height - 6;
    const width = height;

    function getXValues() {
      if (side === Side.RIGHT) {
        const x1 = da.x1 + horizontalMargin;
        const x2 = x1 + width;
        return { x1, x2 };
      } else {
        const x2 = da.x2 - horizontalMargin;
        const x1 = x2 - width;
        return { x1, x2 };
      }
    }

    const { x1, x2 } = getXValues();
    const y1 = da.y1 + (da.height - height) / 2;
    const y2 = y1 + height;
    return toBounds({
      x1,
      x2,
      y1,
      y2,
    });
  }

  return {
    impactTargetSymbolArea,
  };
}
